import React from "react";
import * as Steps from './steps/index';

export default function ResultVersionControl({result}) {
  switch(result.version) {
    case "3.1":
      return <Steps.Quoter3_1 
      productType={"Term3"}
      quoteResultSortDefault={result.quoteResultSortDefault}
      formState={result.formStatePagesQuoter}
      fullFormState={result.fullFormState}
      preQuoteDetails={result.preQuoteDetails}
      isPreQuoteEnabled={result.isPreQuoteEnabled}
      basicInfo={result.basicInfo}
      onNextHandOff={result.onNextHandOff}
      onNext={result.onNext}
      onBack={result.onBack}
      onFieldChange={result.onFieldChange}
      setFormState={result.setFormState}
      onMultiFieldChange={result.onMultiFieldChange}
      setEmailPrefill={result.setEmailPrefill}
      setQuoteEmail={result.setQuoteEmail}
      coverageAmountSpecs={result.coverageAmountSpecs}
      multiTermResult={result.multiTermResult}
    />
    default:
      return <Steps.Quoter
      productType={"Term3"}
      formState={result.formStatePagesQuoter}
      fullFormState={result.fullFormState}
      preQuoteDetails={result.preQuoteDetails}
      isPreQuoteEnabled={result.isPreQuoteEnabled}
      basicInfo={result.basicInfo}
      onNextHandOff={result.onNextHandOff}
      onNext={result.onNext}
      onBack={result.onBack}
      onFieldChange={result.onFieldChange}
      setFormState={result.setFormState}
      onMultiFieldChange={result.onMultiFieldChange}
      setEmailPrefill={result.setEmailPrefill}
      setQuoteEmail={result.setQuoteEmail}
      coverageAmountSpecs={result.coverageAmountSpecs}
      multiTermResult={result.multiTermResult}
    />
  };
}
